import React, { useState, useEffect, useMemo } from "react";
import Dashboard from "components/dashboard";
import { PageSection, PageHeaderBar } from "components/page";
import { useMutation } from "@apollo/react-hooks";
import DataGrid from "components/data-grid";
import { useQuery } from "components/graphql/query/use-query";
import { QueryResponseHandler } from "components/graphql";
import {
  getEditCustomerQuery,
  mutation,
  handleSubmit,
  defaultValues,
  validationSchema,
  EditCustomerForm,
} from "./forms/edit-form";
import ValidatedForm from "components/form";
import { useTablePaginationContext } from "components/table";
import { getEntityWithoutTypename } from "pages/utils";

const CustomerEditPage = ({
  intl,
  history,
  match: {
    params: { id },
  },
}) => {
  const [updateCustomer] = useMutation(mutation);
  const { tablePaginationSize } = useTablePaginationContext();
  const query = useMemo(() => getEditCustomerQuery(id), [id]);
  const { data, loading, error } = useQuery(query);

  const [initialValues, setInitialValues] = useState(defaultValues());
  const customerToEdit = data ? data.customer : null;

  useEffect(
    () => {
      if (customerToEdit) {
        const value = getEntityWithoutTypename(customerToEdit);
        setInitialValues({
          description: value.description,
          contractIds: value.contracts.map(c => c.id),
          userIds: value.userIds,
          partnerId: value.partnerId,
        });
      }
    },
    [customerToEdit],
  );

  return (
    <Dashboard>
      <QueryResponseHandler error={error} loading={loading} elements={customerToEdit}>
        <PageHeaderBar title="app.page.customer.edit" />
        <PageSection>
          <ValidatedForm
            initialValues={initialValues}
            validationSchema={validationSchema(intl)}
            onSubmit={handleSubmit({
              updateCustomer,
              history,
              customerToEdit,
              tablePaginationSize,
              customerId: id,
            })}
          >
            {props => (
              <DataGrid>
                <EditCustomerForm customerId={id} {...props} />
              </DataGrid>
            )}
          </ValidatedForm>
        </PageSection>
      </QueryResponseHandler>
    </Dashboard>
  );
};

export default CustomerEditPage;
